{
  "plus": {
    "profile": {
      "twoFactorAuth": {
        "navigateBackButton": "Takaisin"
      }
    }
  }
}
